// Подсказки всплывающие
import React from 'react';

export const Tooltip = ({ content, type }) => {
    const [showTooltip, setShowTooltip] = React.useState(false);
 
    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
  
    const handleMouseLeave = () => {
        setShowTooltip(false);
    }; 
 
    return (
        <span
            className={`tooltip-wrapper gg-issue ${type==='abs' ? 'tooltip__abs': ''}`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        > 
            {showTooltip && (
                <div className="tooltip font12Norm">{content}</div>
            )}
        </span>
    );
  };
  
  export const TooltipNo = (props) => {
    const [showTooltip, setShowTooltip] = React.useState(false);
  
    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
  
    const handleMouseLeave = () => {
        setShowTooltip(false);
    }; 
    return (
        <span    
          className={`tooltip-wrap`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        > 
        {props.children}
            {showTooltip && (
                <div className="tooltip-no font12Norm">{props.content}</div>
            )}
        </span>
    );
  };

  export const TooltipLabel = (props) => {
    const [showTooltip, setShowTooltip] = React.useState(false);
  
    const handleMouseEnter = () => {
        setShowTooltip(true);
    };
  
    const handleMouseLeave = () => {
        setShowTooltip(false);
    }; 
    return (
        <span    
          className={`gg-label option__label`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >  
            {showTooltip && (
                <div className="tooltip tooltip__label font12Norm">{props.pre} {props.declension} для тарифа <span className='color font12EB'>{props.content}</span> {props.subcontent}</div>
            )}
        </span>
    );
  };
   
   